const TrashCanIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2790_354)">
    <path d="M11.3334 4.00001H14.6667V5.33334H13.3334V14C13.3334 14.1768 13.2631 14.3464 13.1381 14.4714C13.0131 14.5964 12.8435 14.6667 12.6667 14.6667H3.33337C3.15656 14.6667 2.98699 14.5964 2.86197 14.4714C2.73695 14.3464 2.66671 14.1768 2.66671 14V5.33334H1.33337V4.00001H4.66671V2.00001C4.66671 1.8232 4.73695 1.65363 4.86197 1.52861C4.98699 1.40358 5.15656 1.33334 5.33337 1.33334H10.6667C10.8435 1.33334 11.0131 1.40358 11.1381 1.52861C11.2631 1.65363 11.3334 1.8232 11.3334 2.00001V4.00001ZM12 5.33334H4.00004V13.3333H12V5.33334ZM8.94271 9.33334L10.1214 10.512L9.17871 11.4547L8.00004 10.276L6.82137 11.4547L5.87871 10.512L7.05737 9.33334L5.87871 8.15468L6.82137 7.21201L8.00004 8.39068L9.17871 7.21201L10.1214 8.15468L8.94271 9.33334ZM6.00004 2.66668V4.00001H10V2.66668H6.00004Z" fill="#9499AA"/>
    </g>
    <defs>
    <clipPath id="clip0_2790_354">
    <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
  </svg>
);

export default TrashCanIcon;
